import type { JSX, ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { DataProvider } from './types';

const DataProviderContext = createContext<DataProvider | null>(null);

export function DataProviderProvider({
  provider,
  children,
}: {
  provider: DataProvider;
  children: ReactNode;
}): JSX.Element {
  return <DataProviderContext.Provider value={provider}>{children}</DataProviderContext.Provider>;
}

export function useDataProvider(): DataProvider {
  const context = useContext(DataProviderContext);
  if (!context) {
    throw new Error('DataProvider not available in component tree');
  }
  return context;
}
